import { Modal, Container, Col, Row } from 'react-bootstrap'

const ModalVideo: React.FC<{
  onHide: () => void
  show: boolean
  src: string
}> = ({
  onHide,
  show,
  src
}) => {

    return (
      <Modal size='lg' centered className='modal-video' show={show} onHide={onHide}>
        <Modal.Body className="show-grid" >
          <Container fluid style={{ padding: 0 }}>
            <Row>
              <Col style={{ textAlign: 'center', padding: 0 }}>
                <iframe
                  width="100%"
                  height="450"
                  src={src}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    )
  }

export default ModalVideo
